import { toTypeId, type ExclusionAreaFeature } from './exclusionAreaTypeResolution'
import { getFeatureDisplayName } from './getFeatureDisplayName'

export const findDuplicatesFeaturesNamesAndExclusionAreaTypeIdIndexes = (
  features: ExclusionAreaFeature[] | null | undefined,
): number[] => {
  if (!features?.length) return []

  const indexesByNameAndType = new Map<string, number[]>()

  features.forEach(({ properties }, index) => {
    const key = `${getFeatureDisplayName(properties)}-${toTypeId(properties?.exclusionAreaTypeId)}`
    indexesByNameAndType.set(key, [...(indexesByNameAndType.get(key) || []), index])
  })

  return [...indexesByNameAndType.values()].filter(indexes => indexes.length > 1).flat()
}
